import { IWPImage } from "@/src/types";
import { MainSection } from "@/styles/global";
import React from "react";
import S from "./HeaderSubpage.styled";
import { getBgColor } from "@/src/helpers";
import BreadCrumbs, {
  BreadCrumbProps,
} from "@/components/global-components/Breadcrumbs";

export type HeaderSubpageProps = {
  backgroundColor: string;
  hasBackgroundImage: boolean;
  image?: IWPImage;
  ingress?: string;
  title: string;
  hasIcon?: boolean;
  categoryIcon?: {
    altText: string;
    sourceUrl: string;
  };
  breadcrumb: BreadCrumbProps;
};

const HeaderSubpage: React.FC<HeaderSubpageProps> = ({
  backgroundColor,
  hasBackgroundImage,
  image,
  ingress,
  title,
  breadcrumb,
  hasIcon,
  categoryIcon,
}) => {
  const hasImage = hasBackgroundImage && image?.localFile?.publicURL;

  return (
    <MainSection
      $bgImage={hasImage || ""}
      $bgColor={getBgColor("dark", backgroundColor)}
    >
      <S.Inner $bgImage={hasImage || ""}>
        <S.ContentWrapper
          $bgColor={getBgColor("dark", backgroundColor)}
          $hasImage={hasBackgroundImage}
        >
          <BreadCrumbs
            breadcrumb={breadcrumb}
            color={backgroundColor}
            title={title}
          />
          <S.FlexWrapper $hasIcon={hasIcon}>
            {hasIcon && (
              <S.Icon
                src={categoryIcon?.sourceUrl}
                alt={categoryIcon?.altText}
              />
            )}
            <S.TextWrapper>
              {title && <S.Title>{title}</S.Title>}
              {ingress && <S.Ingress>{ingress}</S.Ingress>}
            </S.TextWrapper>
          </S.FlexWrapper>
        </S.ContentWrapper>
      </S.Inner>
    </MainSection>
  );
};

export default HeaderSubpage;
